
@switch (section.type) {
  <!-- Transit section: Show boarding or drop-off station info based on user state -->
  @case (sectionTypes.TRANSIT) {
    <div
      class="rounded-xl flex flex-col border border-solid border-[#09223E] min-h-[4.6875rem] w-full relative bg-white">
      <!-- Header: Dark blue background with white text -->
      <div class="flex justify-between items-center bg-[#09223E] text-white px-4 py-2 rounded-t-xl">
        <!-- Show "Get on" if user hasn't boarded, "Get off" if user is on bus -->
        <span class="text-white font-medium">
          {{ shouldShowDropOff ? dropOffText : boardOnText }}
        </span>
        <!-- Show departure time if waiting, arrival time if on bus -->
        @if (shouldShowDropOff ? section.arrival?.hourTimeString : section.departure?.hourTimeString) {
          <span class="text-white font-medium">
            {{ (shouldShowDropOff ? section.arrival.hourTimeString : section.departure.hourTimeString) | hour }}
          </span>
        }
      </div>
      <!-- Body: White background with dark blue text -->
      <div class="px-4 py-3 bg-white rounded-b-xl">
        <!-- Station name: Show departure station if waiting, arrival station if on bus -->
        <div class="text-[#09223E] text-base font-normal mb-1">
          {{ shouldShowDropOff ? section.arrival?.place?.name : section.departure?.place?.name }}
        </div>
        <!-- Station code -->
        @if (shouldShowDropOff ? section.arrival?.place?.code : section.departure?.place?.code) {
          <div class="text-[#09223E] text-sm font-normal">
            {{ stationCodeText }}: {{ shouldShowDropOff ? section.arrival.place.code : section.departure.place.code }}
          </div>
        }
        @if (!shouldShowDropOff && transportLineLabel) {
          <div
            class="text-[#09223E] text-sm font-medium mt-2 pt-2 border-t border-[#09223E]/15"
            >
            {{ waitForLineText }} {{ transportLineLabel }}
            @if (section.transport?.headsign) {
              <span
                class="block text-xs font-normal mt-1 opacity-90"
                >
                {{ toDirectionText }} {{ section.transport.headsign }}
              </span>
            }
          </div>
        }
      </div>
    </div>
  }
  <!-- Pedestrian section: Use existing component -->
  @case (sectionTypes.PEDESTRIAN) {
    <div
      class="rounded-xl flex flex-col px-2 border border-solid border-[#09223E] min-h-[4.6875rem] w-full"
      [ngClass]="{ 'bg-[#09223E]': !!isActive }">
      <app-detailed-result-route-pedestrian [section]="section" />
    </div>
  }
}
